var map = {
	"./bg1.png": "5aee",
	"./bg10.png": "762a",
	"./bg11.png": "8f79",
	"./bg12.png": "a90d",
	"./bg13.png": "42c0",
	"./bg14.png": "2759",
	"./bg15.png": "dbf2",
	"./bg16.png": "f86c",
	"./bg17.png": "dde6",
	"./bg18.png": "3a3f",
	"./bg19.png": "ef2a",
	"./bg2.png": "2cee",
	"./bg20.png": "186f",
	"./bg21.png": "563d",
	"./bg3.png": "d871",
	"./bg4.png": "263f",
	"./bg5.png": "ee1b",
	"./bg6.png": "5def",
	"./bg7.png": "a2ce",
	"./bg8.png": "95fc",
	"./bg9.png": "4804"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ec0";